export default __webpack_public_path__ + "static/media/Solcito.b991811d.png";